export const errorMessages = {
  required: 'This is a required field.',
  maxLength: 'Max length is 50 characters',
  phone: 'Phone number must be valid for entry.',
  email: 'Email address must be valid for entry.',
  postalCode: 'Postal code must be valid for entry.',
  dob: 'This is a required field and you have to be the age of majority to enter.',
};
